module.exports = __webpack_public_path__ + "static/img/01037A_C_2_4_20180322_fit.e553d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01037A_C_2_4_20180322_fit.png
// module id = rO2L
// module chunks = 0